import { render, staticRenderFns } from "./process13.vue?vue&type=template&id=2848ec50&scoped=true&"
import script from "./process13.vue?vue&type=script&lang=js&"
export * from "./process13.vue?vue&type=script&lang=js&"
import style0 from "./process13.vue?vue&type=style&index=0&id=2848ec50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2848ec50",
  null
  
)

export default component.exports